import { CitySearchResult } from '@models';

export function getCityDescription(city: CitySearchResult): string {
  return city?.Present;
}
